document.addEventListener('DOMContentLoaded',()=>{
  const root=document.querySelector('[data-pr-dental]');
  if(!root)return;
  const setLang=lang=>{
    root.dataset.lang=lang;
    root.querySelectorAll('[data-i18n]').forEach(el=>{el.hidden=el.dataset.i18n!==lang});
    root.querySelectorAll('[data-lang]').forEach(el=>el.classList.toggle('active',el.dataset.lang===lang));
    root.setAttribute('lang',lang);
  };
  root.querySelectorAll('[data-lang]').forEach(button=>button.addEventListener('click',()=>setLang(button.dataset.lang)));
  root.querySelectorAll('[data-faq-button]').forEach(button=>button.addEventListener('click',()=>{
    const item=button.closest('.faq-item');
    const open=item.classList.toggle('open');
    button.setAttribute('aria-expanded',String(open));
    button.querySelector('b').textContent=open?'−':'+';
  }));
  root.querySelectorAll('[data-product-modal]').forEach(button=>button.addEventListener('click',()=>{
    const modal=root.querySelector(`#product-${button.dataset.productModal}`); modal.hidden=false; document.body.classList.add('modal-open');
  }));
  root.querySelectorAll('[data-close]').forEach(button=>button.addEventListener('click',()=>{
    button.closest('.modal').hidden=true; document.body.classList.remove('modal-open');
  }));
  root.querySelectorAll('.modal').forEach(modal=>modal.addEventListener('click',event=>{
    if(event.target===modal){modal.hidden=true;document.body.classList.remove('modal-open')}
  }));
  setLang('es');
});
